/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Back Icon component.
 */
export const MaterialForwardIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='MaterialForwardIcon' size={iconSize} color={iconColor as any} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
        <path d='M14.9995 26.1333L16.8662 28L24.8662 20L16.8662 12L14.9995 13.8667L21.1329 20L14.9995 26.1333Z'
          fill={iconColor}
          fillRule='evenodd'
          clipRule='evenodd' />
      </svg>
    )} />
  );
};

MaterialForwardIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey1
};

export default MaterialForwardIcon;
